import React from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { FaShoppingCart, FaPrint } from "react-icons/fa";
import { useLanguage } from "../context/LanguageContext";
import { useRidePreview } from "../hooks/useRidePreview";
import RidePreviewModal from "../components/Modals/RidePreviewModal";
import { API_BASE } from "../utils/api";

export default function OrderConfirmation() {
    const history = useHistory();
    const user = JSON.parse(localStorage.getItem("user"));
    const isAdvisor = !user?.changeCustomer && user?.groupId === "     1";
    const isSupervisor = user?.groupId === "     9";
    const CANCEL_WINDOW_HOURS = (Number(user?.demanda) || 0) * 24;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    // Datos simulados por ahora
    const confirmation = JSON.parse(
        localStorage.getItem("order_confirmation")
    );

    const isProforma = confirmation?.isProforma;
    const { t, switchLanguage, language } = useLanguage();
    const { rideOpen, rideUrl, openRidePreview, closeRidePreview } = useRidePreview();

    const handlePrintRide = () => {
        const id = confirmation?.orderId || confirmation?.orderNumber;
        if (!id) return;
        openRidePreview(
            `${API_BASE}/orders-ultra/api/ws/generate_ride_order?order_id=${id}`
        );
    };
    return (
        <div className="w-full min-h-screen px-4 sm:px-6 lg:px-16 py-12 mt-12">

            {/* Mensaje principal */}
            <h1 className="text-2xl sm:text-3xl font-semibold mb-4">
                {isProforma
                    ? "Su Solicitud de Proforma fue enviada!"
                    : isAdvisor
                        ? t.confirmTitle2
                        : t.confirmTitle1}
            </h1>

            <p className="hidden text-gray-700 mb-2">
                {t.thankYouForInterest}
                {user?.companyName && (
                    <>
                        , <span className="font-bold">{user.companyName}</span>
                    </>
                )}
                !
            </p>

            <p className="text-gray-600 mb-4">
                {isProforma
                    ? "Su Solicitud de Proforma ha sido enviada y está siendo procesada."
                    : isAdvisor
                        ? t.emailConfirmationNotice2
                        : t.emailConfirmationNotice1}
            </p>

            {/* Info pedido */}
            <div className="space-y-1 text-sm text-gray-700 mb-8">
                <div>
                    <span className="font-medium">
                        {isProforma ? "Su número de Solicitud de Proforma es" : t.webOrderNumberLabel}:{" "}
                    </span>
                    <span className="font-bold text-xl">
                        {confirmation?.orderNumber}
                    </span>
                </div>
                {/* ESTADO */}
                <div
                    className={`mt-3 inline-flex items-center gap-2 px-3 py-1.5 
                        rounded-full text-sm font-semibold text-black
                    ${isProforma
                            ? "bg-yellow-100"
                            : isAdvisor
                                ? "bg-yellow-100"
                                : "bg-green-100"}`}
                >
                    {isProforma
                        ? "Solicitud de Proforma Enviada"
                        : isAdvisor
                            ? t.orderApproved2
                            : t.orderApproved1}
                </div>
                {!isProforma && !isAdvisor && CANCEL_WINDOW_HOURS > 0 && (
                    <div className="mt-2 text-sm text-gray-600">
                        {t.approveSuccessTimePrefix} {CANCEL_WINDOW_HOURS}{" "}
                        {CANCEL_WINDOW_HOURS === 1 ? t.hourLabelSingular : t.hourLabelPlural}{" "}
                        {t.approveSuccessTimeSuffix}
                    </div>
                )}
                <div>
                    <span className="font-medium">{isProforma ? "Fecha de Solicitud de Proforma" : t.orderDate}: </span>
                    <span className="font-bold">
                        {new Date(confirmation?.orderDate || new Date()).toLocaleString("es-ES", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                        })}
                    </span>

                </div>

            </div>

            <p className="text-gray-600 mb-8">
                {t.questionsOrComments}
            </p>

            {/* BOTONES */}
            <div className="flex flex-wrap gap-4">
                <button
                    onClick={() => history.push("/dashboard")}
                    className={`
                        flex items-center gap-2 text-black
                        ${isProforma
                            ? "bg-[#FFFFB3] hover:brightness-90"
                                : "bg-[#80FF80] hover:brightness-90"}
                        px-5 py-2.5
                        rounded-lg
                        font-medium
                        transition
                    `}
                >
                    <FaShoppingCart />
                    {isProforma ? "Realizar otra Solicitud de Proforma" : t.continueShopping}
                </button>


                <button
                    onClick={handlePrintRide}
                    className="
                            flex items-center gap-2
                            bg-gray-200
                            text-gray-40
                            px-5 py-2.5
                            rounded-lg
                            font-medium
                            cursor-pointer
                        "
                >
                    <FaPrint />
                  Imprimir comprobante
                </button>

            </div>

            <RidePreviewModal
                open={rideOpen}
                url={rideUrl}
                onClose={closeRidePreview}
            />
        </div>
    );
}
